<template>
  <UDropdownMenu
    :items="items"
    :content="{ align: 'center', collisionPadding: 12 }"
    :ui="{ content: collapsed ? 'w-40' : 'w-(--reka-dropdown-menu-trigger-width)' }"
  >
    <UButton
      v-bind="{
        ...user.user,
        trailingIcon: collapsed ? undefined : 'i-lucide-chevrons-up-down',
      }"
      color="neutral"
      variant="ghost"
      block
      :square="collapsed"
      class="data-[state=open]:bg-elevated"
      :class="[!collapsed && 'py-2']"
      :ui="{
        trailingIcon: 'text-dimmed',
      }"
    >
      <UAvatar
        :alt="user.user?.name.toUpperCase()"
        size="xs"
      />
      {{ user.user?.name }}
    </UButton>
  </UDropdownMenu>
</template>

<script setup lang="ts">
import type { DropdownMenuItem } from '@nuxt/ui'

defineProps<{
  collapsed?: boolean
}>()

const user = useUserStore()

type Mode = 'auto' | 'dark' | 'light'
const currentTheme = useTheme()
const theme = computed<Mode>(() => currentTheme.store.value === 'auto' ? 'auto' : currentTheme.store.value)

const items = computed<DropdownMenuItem[]>(() => [
  {
    label: 'Settings',
    icon: 'i-lucide-settings',
    to: '/portal/profile',
  },
  {
    label: 'Theme',
    icon: 'i-lucide-sun-moon',
    children: [
      {
        label: 'Light',
        type: 'checkbox',
        icon: 'i-lucide-sun',
        checked: theme.value === 'light',
        onSelect: (e) => {
          e.preventDefault()
          currentTheme.value = 'light'
        },
      },
      {
        label: 'Dark',
        type: 'checkbox',
        icon: 'i-lucide-moon',
        checked: theme.value === 'dark',
        onSelect: (e) => {
          e.preventDefault()
          currentTheme.value = 'dark'
        },
      },
      {
        label: 'Auto',
        type: 'checkbox',
        icon: 'i-lucide-settings',
        checked: theme.value === 'auto',
        onSelect: (e) => {
          e.preventDefault()
          currentTheme.value = 'auto'
        },
      },
    ],
  },
  {
    label: 'Logout',
    icon: 'i-lucide-log-out',
    onSelect: async () => {
      user.logout()
      return navigateTo('/')
    },
  },
])
</script>
